import { ofType } from 'redux-observable'

import APP, { epicErrorHandler, epicResponseHandler, epicServerRequest } from 'app'

import { catchError, map, mergeMap, takeUntil } from 'rxjs/operators'

export const TRN_CREATOR_SAVE_FETCH = 'TRN_CREATOR_SAVE_FETCH'
export const TRN_CREATOR_SAVE_FETCH_CANCELED = 'TRN_CREATOR_SAVE_FETCH_CANCELED'
export const TRN_CREATOR_SAVE_FETCH_ERROR = 'TRN_CREATOR_SAVE_FETCH_ERROR'
export const TRN_CREATOR_SAVE_FETCH_FULFILLED = 'TRN_CREATOR_SAVE_FETCH_FULFILLED'

export const creatorSaveFetch = (payload) => ({
  notification: {
    id: TRN_CREATOR_SAVE_FETCH,
    children: 'Creando...',
    title: 'Creando torneo',
  },
  payload,
  type: TRN_CREATOR_SAVE_FETCH,
})

export const creatorSaveFetchFulfilled = (payload) => ({
  notification: {
    id: TRN_CREATOR_SAVE_FETCH,
    children: 'Creado!!',
    title: 'Creando torneo',
  },
  payload,
  type: TRN_CREATOR_SAVE_FETCH_FULFILLED,
})

export const creatorSaveFetchCanceled = () => ({
  payload: null,
  type: TRN_CREATOR_SAVE_FETCH_CANCELED,
})

export const creatorSaveFetchError = (payload) => ({
  payload,
  type: TRN_CREATOR_SAVE_FETCH_ERROR,
})

export const creatorSaveFetchEpic = (action$) =>
  action$.pipe(
    ofType(TRN_CREATOR_SAVE_FETCH),
    mergeMap((action) => {
      const formData = new FormData()
      Object.keys(action.payload)
        .filter((key) => action.payload[key])
        .forEach((key) => formData.append(key, action.payload[key]))

      return epicServerRequest('post', `${APP.api_url}/sports/tournaments/creator`, action, formData).pipe(
        map(epicResponseHandler(creatorSaveFetchFulfilled, action)),
        takeUntil(action$.pipe(ofType(TRN_CREATOR_SAVE_FETCH_CANCELED))),
        catchError(epicErrorHandler(creatorSaveFetchError, action)),
      )
    }),
  )
